import { Typography } from '@mui/material';
import { FieldError } from 'react-hook-form';

import { Colors } from '../../../shared/colors';

interface Props {
  error?: FieldError | string;
}

const InputError = ({ error }: Props) => {
  const message = !!error && typeof error !== 'string' ? error.message : error;

  return message ? (
    <Typography mt={0.5} color={Colors.error.dark}>
      {message}
    </Typography>
  ) : null;
};

export default InputError;
